import { render, staticRenderFns } from "./Idea.vue?vue&type=template&id=4822708c&"
import script from "./Idea.vue?vue&type=script&lang=js&"
export * from "./Idea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports